export const localStorageSave = <T>(key: string, value: T): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (_) {}
};

export const localStorageGet = <T>(key: string): T | null => {
  try {
    const value = window.localStorage.getItem(key);

    if (value) {
      return JSON.parse(value) as T;
    }
  } catch (_) {}
  return null;
};

export const localStorageClear = (key: string): void => {
  try {
    window.localStorage.removeItem(key);
  } catch (_) {}
};

type LocalStorageItemWithExpiration<T> = {
  value: T;
  expirationTime: number;
};

export const localStorageSaveWithExpiration = <T>(
  key: string,
  value: T,
  expirationDays: number = 30,
): void => {
  const HOURS_PER_DAY = 24;
  const MINUTES_PER_HOUR = 60;
  const SECONDS_PER_MINUTE = 60;
  const MILLISECONDS_PER_SECOND = 1000;

  try {
    const expirationTime =
      Date.now() +
      expirationDays *
        HOURS_PER_DAY *
        MINUTES_PER_HOUR *
        SECONDS_PER_MINUTE *
        MILLISECONDS_PER_SECOND;
    const item: LocalStorageItemWithExpiration<T> = {
      value,
      expirationTime,
    };
    window.localStorage.setItem(key, JSON.stringify(item));
  } catch (_) {}
};

export const localStorageGetWithExpiration = <T>(key: string): T | null => {
  try {
    const value = window.localStorage.getItem(key);

    if (value) {
      const item: LocalStorageItemWithExpiration<T> = JSON.parse(value);

      // Check if the item has expired
      if (Date.now() > item.expirationTime) {
        // Remove expired item
        localStorageClear(key);
        return null;
      }

      return item.value;
    }
  } catch (_) {}
  return null;
};
